import { IconButton, BackIcon, ThemeSpaceVariable } from "@caspeco/casper-ui-library";

interface IBackButtonProps {
	onClick: () => void;
	mb?: ThemeSpaceVariable;
	"data-testid"?: string;
}
export const BackButton = (props: IBackButtonProps) => {
	const { onClick, mb, "data-testid": dataTestId } = props;
	return (
		<IconButton
			aria-label="Back"
			icon={BackIcon}
			variant="ghost"
			onClick={onClick}
			mb={mb ? mb : ThemeSpaceVariable.None}
			data-testid={dataTestId}
		/>
	);
};
